export default {
  author: {
    authorProfile: 'Sobre o author',
    by: 'Por',
    on: 'em'
  }
}
